import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { environment } from '@src/environments/environment';
import { Task } from '@src/app/models/task';


@Injectable({
  providedIn: 'root'
})
export class TasknameService {

  constructor(private http:HttpClient) {

   }
  getTaskname(taskId:string, projectId:string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    ///project/{projectId}/task/{taskId}/pit/{pitdate}
    return this.http.get<Task>(environment.apiUrl+'/project/'+projectId+'/task/'+taskId+'/pit/'+new Date().toISOString(),httpOptions);
  }
}
